// extracted by mini-css-extract-plugin
export default {"page":"cx_Vd","page__table":"LxApG","appear-from-above":"Q6Iug","appearFromAbove":"Q6Iug"};